/* eslint-disable camelcase */
// eslint-disable-next-line @typescript-eslint/no-empty-interface -- declaration merging gives the class PharmacyResponse's typed fields
interface Pharmacy extends PharmacyResponse {}

class Pharmacy {
  constructor(pharmacyData: PharmacyResponse) {
    Object.assign(this, pharmacyData);
  }

  isDeliverySubscriptionEnabled(): boolean {
    if (!this?.chain?.paid_delivery?.subscriptions_offered) return false;

    const pharmacyOffersLocalDelivery = Boolean(this.delivery?.active);
    const pharmacyOffersPostalDelivery = Boolean(this.postal_partner?.active);
    if (!pharmacyOffersLocalDelivery && !pharmacyOffersPostalDelivery) return false;

    const pharmacyOffersPaidRxDelivery = Boolean(
      this.charge_for_delivery?.local_delivery?.repeat ||
        this.charge_for_delivery?.postal_delivery?.repeat
    );
    if (!pharmacyOffersPaidRxDelivery) return false;

    return true;
  }

  offersClinicFulfilment(): boolean {
    return (
      Boolean(this.delivery_options?.collection?.private_prescription) ||
      Boolean(this.delivery_options?.postal_delivery?.private_prescription)
    );
  }
}

export interface PharmacyResponse extends Record<string, unknown> {
  _id: string;
  chain_id?: string;
  chain?: {
    paid_delivery?: { subscriptions_offered?: boolean };
    saas_billing?: { payment_overdue?: boolean };
    primaryUser?: { email?: string };
    feature_flags?: {
      assisted_ordering?: boolean;
      basic_pro_features?: boolean;
      marketing_material?: boolean;
      pgds?: boolean;
      pro_activation_journey?: boolean;
      segmented_broadcast?: boolean;
      sms_campaigns?: boolean;
      super_links?: boolean;
      what_is_new?: boolean;
    };
    white_label_name?: string;
  };
  delivery?: { active?: boolean };
  postal_partner?: { active?: boolean };
  pharmacy_name?: string;
  charge_for_delivery?: {
    local_delivery?: { repeat?: boolean };
    postal_delivery?: { repeat?: boolean };
  };
  delivery_options?: {
    collection?: { private_prescription?: boolean };
    postal_delivery?: { private_prescription?: boolean };
  };
  timezone?: string;
}

export default Pharmacy;
